module.exports = __webpack_public_path__ + "static/img/convocatoriaONU_UNDP-BOL-00144-2.ad3c7b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/convocatoriaONU_UNDP-BOL-00144-2.jpg
// module id = f8Xv
// module chunks = 9